// src/admin/Portal.tsx — FINAL NAKAMA-FREE
import { Link } from 'react-router-dom';
import { Shield, Users } from 'lucide-react';

export default function AdminPortal() {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-indigo-900 via-purple-800 to-pink-700 text-white">
      <header className="flex justify-between items-center p-4 sm:p-6 bg-black bg-opacity-60 shadow-lg">
        <div className="flex items-center gap-3">
          <img src="/BolsaFish.png" alt="Bolsa Fish" className="bf-logo-ring h-10 w-10 sm:h-12 sm:w-12 rounded-full object-contain p-1" />
          <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">Bolsa Fish</h1>
        </div>
        <nav className="flex gap-4 sm:gap-6">
          <Link
            to="/admin/login"
            className="bf-glossy-btn flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-3 rounded-xl transition transform hover:scale-105 text-sm sm:text-base font-semibold"
          >
            <Shield className="w-5 h-5" />
            <span className="hidden sm:inline">Admin Login</span>
            <span className="sm:hidden">Admin</span>
          </Link>
          <Link
            to="/manager/login"
            className="bf-glossy-btn flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-3 rounded-xl transition transform hover:scale-105 text-sm sm:text-base font-semibold"
          >
            <Users className="w-5 h-5" />
            <span className="hidden sm:inline">Manager Login</span>
            <span className="sm:hidden">Manager</span>
          </Link>
        </nav>
      </header>

      <main className="flex-grow flex flex-col items-center justify-center text-center py-12 px-4 sm:px-6 lg:py-20">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 tracking-wide">
          Admin & Manager Portal
        </h2>
        <p className="text-lg sm:text-xl lg:text-2xl max-w-xl sm:max-w-2xl mb-8 sm:mb-12 text-gray-200 leading-relaxed">
          Full control over users, credits, tables, cashouts, RTP, and real-time game data.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
          <Link
            to="/admin/login"
            className="bf-glossy-btn px-6 py-3 sm:px-10 sm:py-4 text-lg sm:text-xl font-semibold rounded-xl transition transform hover:scale-110 shadow-md"
          >
            Admin Access
          </Link>
          <Link
            to="/manager/login"
            className="bf-glossy-btn px-6 py-3 sm:px-10 sm:py-4 text-lg sm:text-xl font-semibold rounded-xl transition transform hover:scale-110 shadow-md"
          >
            Manager Access
          </Link>
        </div>
      </main>

      <footer className="p-4 sm:p-6 text-center text-sm sm:text-base bg-black bg-opacity-70 text-gray-300">
        <p>
          © {new Date().getFullYear()} Bolsa Fish. All rights reserved.<br />
          Powered by <strong>Custom Authoritative Server</strong> & Express
        </p>
      </footer>
    </div>
  );
}
